var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoresultFoundImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 219,
    viewBox: "0 0 280 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.096 80.2312L237.99 87.2567V79.3843L232.096 80.2312Z",
    fill: "#D5D1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.031 26.8943C227.136 25.6516 223.95 24.9644 220.604 24.9644C207.379 24.9644 196.653 35.69 196.653 48.9149C196.653 57.1345 206.796 53.6773 213.113 57.9884C216.959 60.6125 220.604 72.8655 220.604 72.8655C224.714 72.8655 228.58 71.8311 231.954 70.0053C231.954 70.0053 231.573 57.1414 231.496 53.7328L237.987 54.8783V37.6755C234.238 35.1 231.399 31.3095 230.031 26.8873V26.8943Z",
    fill: "#F9F8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8329 142.996C37.5505 140.504 33.5657 131.215 26.0682 127.633C12.3781 121.101 -2.54758 132.562 1.41642 147.793C5.41512 163.163 23.1524 166.933 21.5696 179.929C20.9656 184.879 20.7921 189.738 21.8126 194.48H55.1421L44.8399 142.989L44.8329 142.996Z",
    fill: "#D5D1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.15 127.793C96.6025 121.441 93.055 122.586 84.2523 122.079C73.353 121.455 71.3051 113.922 68.5282 107.32C66.8135 103.238 60.2462 94.0676 47.7363 96.4001C41.1274 97.8025 35.7472 103.12 34.2129 112.02C31.5194 127.668 49.2428 136.776 43.8556 148.71C37.087 163.705 36.4344 180.033 55.1367 194.493H91.9651C91.9651 194.493 87.8067 174.069 83.5511 154.437C87.3832 150.82 105.211 133.471 101.143 127.793H101.15Z",
    fill: "#F7F6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8893 182.094L50.165 111.596",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3085 129.174L66.436 142.837",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6149 164.294L51.6511 165.711",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5138 166.412L17.0974 141.378",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7528 159.595L21.5828 159.227",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0669 149.161L24.6778 139.47",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1562 185.649L33.6394 187.211",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.353 114.428C209.097 116.462 209.451 121.662 215.338 121.662L210.353 114.428Z",
    fill: "#9A8FB7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.262 109.097C221.685 109.124 222.817 109.583 223.4 110.242C224.719 111.742 224.608 114.519 223.65 116.164L220.262 109.097Z",
    fill: "#9A8FB7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.801 180.81L126.414 101.62C100.34 106.431 79.9711 128.577 78.5202 156.22C77.7635 170.598 82.2551 184.045 90.315 194.687L184.257 194.201C189.429 187.231 193.087 179.053 194.753 170.126L189.089 158.199L111.801 180.81Z",
    fill: "#FBF7CE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.121 111.478L133.682 155.915L135.564 155.096L134.863 157.345L189.102 132.131C180.959 116.58 166.012 105.042 148.004 101.662C153.461 107.764 151.128 111.471 151.128 111.471L151.121 111.478Z",
    fill: "#FBF7CE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.966 194.722C172.838 209.377 155.01 218.583 135.225 217.916C116.842 217.291 100.722 208.28 90.4268 194.681",
    stroke: "#DA4A8E",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.725 93.1509C136.725 93.1509 141.668 95.6848 146.423 100.038C152.012 105.147 152.796 109.007 151.415 110.333C150.033 111.652 143.521 110.604 135.302 103.099L136.732 93.1578L136.725 93.1509Z",
    fill: "#9A8FB7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M173.391 68.3878C171.69 79.3009 171.614 116.317 188.511 117.983C197.043 118.823 206.589 109.236 208.165 85.2642C208.165 85.2642 212.386 90.0752 216.579 85.2642C222.063 78.9607 220.938 64.9236 214.739 65.4443C210.303 65.8192 208.866 71.5326 208.866 71.5326",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.162 85.2642L223.643 116.171",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.095 121.593L204.008 105.216",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M176.085 80.2314C176.833 80.2314 177.439 79.6253 177.439 78.8777C177.439 78.13 176.833 77.5239 176.085 77.5239C175.337 77.5239 174.731 78.13 174.731 78.8777C174.731 79.6253 175.337 80.2314 176.085 80.2314Z",
    fill: "#0E090C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M191.266 79.3842C192.013 79.3842 192.619 78.7781 192.619 78.0305C192.619 77.2828 192.013 76.6768 191.266 76.6768C190.518 76.6768 189.912 77.2828 189.912 78.0305C189.912 78.7781 190.518 79.3842 191.266 79.3842Z",
    fill: "#0E090C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M225.98 69.3322C228.916 64.542 229.472 60.1199 225.695 56.5793C222.439 53.5248 222.391 50.9631 223.05 44.6388C223.71 38.3144 219.371 34.163 212.574 34.4476C207.673 34.6489 207.479 29.4423 203.043 28.6925C198.607 27.9358 196.531 30.8654 194.171 31.3375C189.013 32.3719 186.617 28.3177 181.619 31.3375C176.614 34.3574 178.03 38.4186 176.433 40.0222C174.837 41.6258 170.859 41.5356 170.727 47.6656C170.685 49.5538 171.317 50.9839 172.324 52.06L182.14 47.2699C183.257 50.2203 180.224 52.9347 177.537 54.6772C177.745 54.7258 177.961 54.7674 178.169 54.8021L191.769 48.9221C192.99 52.7334 192.845 55.7463 191.685 58.1691C195.878 60.342 199.183 57.0098 201.259 59.745C203.334 62.4802 207.208 59.4604 207.77 62.39C208.34 65.3126 205.313 65.3126 204.952 68.8115C204.591 72.3034 206.257 72.4006 206.257 75.1844C206.257 77.9683 203.612 78.8846 203.612 78.8846L206.535 81.0784C208.937 78.0377 208.624 76.073 209.096 72.1993C209.568 68.3325 212.422 64.91 215.608 65.4792C218.642 66.0207 222.203 70.4151 218.94 80.2314C217.038 85.9587 214.116 87.8401 210.61 86.8959C209.131 86.5002 208.159 85.2714 208.159 85.2714L212.623 94.1783C215.684 94.4421 217.677 92.9703 218.621 88.6315C219.565 84.2926 221.738 84.6675 223.647 83.0499C229.527 78.0654 222.398 75.1914 225.987 69.346L225.98 69.3322Z",
    fill: "#0E090C",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M172.316 52.0532L132.177 71.6372L128.421 92.9081C128.421 92.9081 130.955 98.8436 135.287 103.099L138.917 77.8643C138.917 77.8643 140.993 83.5708 148.942 81.6686C156.891 79.7665 163.465 79.4194 163.465 89.6174C163.465 89.6174 168.651 90.4852 168.477 84.2581C168.304 78.0309 164.159 75.0944 161.737 73.7129C161.737 73.7129 170.553 73.0187 170.727 69.3948C170.727 69.3948 173.837 68.1869 181.793 65.417C186.437 63.7994 190.054 61.571 191.678 58.1693",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.164 54.795L173.936 56.6208C173.936 56.6208 175.651 55.8849 177.532 54.6631",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M148.975 77.5862C148.975 77.5862 155.368 75.3994 157.555 69.2486C157.555 69.2486 167.587 69.1653 166.052 61.0776L169.947 67.999",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M166.053 61.0776C166.053 61.0776 170.351 58.5784 173.94 56.6207C177.529 54.67 181.368 52.9414 182.326 49.1162",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M167.816 64.2429C167.816 64.2429 180.215 59.2168 184.096 57.5159C187.976 55.8151 192.877 54.142 191.767 48.9146",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M169.481 67.1733C169.481 67.1733 180.776 62.7789 185.066 61.085C189.357 59.3842 192.939 57.1627 192.939 52.9141",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M161.742 73.706C161.742 73.706 169.975 73.345 170.732 69.388C170.732 69.388 175.494 67.7149 179.875 66.0835C184.255 64.4521 188.886 62.8692 191.135 59.1621",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M182.327 72.1987L180.404 96.7811H186.52",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M189.104 76.9061C189.104 76.9061 190.346 75.1775 193.172 75.6149C195.824 76.0244 197.441 78.6 197.441 78.6",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M173.966 78.0307C173.966 78.0307 174.48 76.6144 176.431 76.4964C178.687 76.3576 180.145 78.5999 180.145 78.5999",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M185.41 102.28C186.951 100.961 189.923 101.683 189.923 104.557C189.923 106.938 187.243 107.826 185.681 106.619",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M207.804 123.439L134.862 157.345",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M237.985 109.41L230.627 112.832",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M151.681 110.062C149.453 112.769 140.858 108.785 135.297 103.092C129.737 97.3994 128.168 92.165 128.168 92.165L111.812 180.81L189.099 158.199L206.33 194.486",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M132.937 163.496L135.561 155.096L127.259 158.713",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.691 155.915L151.685 110.062",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M219.904 120.273C224.465 124.744 224.042 131.263 223.646 135.602C223.167 140.878 224.681 145.814 232.067 148.854C239.454 151.895 241.738 156.401 241.842 163.489C241.987 173.11 242.925 180.143 254.227 184.704",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M229.381 143.044C230.578 143.044 231.547 142.075 231.547 140.878C231.547 139.682 230.578 138.712 229.381 138.712C228.185 138.712 227.215 139.682 227.215 140.878C227.215 142.075 228.185 143.044 229.381 143.044Z",
    fill: "#9A8FB7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M249.096 177.45C250.292 177.45 251.262 176.48 251.262 175.284C251.262 174.087 250.292 173.118 249.096 173.118C247.9 173.118 246.93 174.087 246.93 175.284C246.93 176.48 247.9 177.45 249.096 177.45Z",
    fill: "#9A8FB7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M138.922 77.8569L135.291 103.092",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M237.986 79.3843V194.486H54.4902",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M237.987 37.6826V54.6702",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M153.281 85.2641C131.413 88.8949 99.7632 81.7583 92.9252 52.615C89.8428 39.4803 94.2997 26.2832 103.644 26.2832C115.092 26.2832 119.673 40.8965 117.001 54.2603C114.62 66.18 106.4 80.0644 85.1082 80.349C75.8612 80.474 68.7038 77.4055 63.3306 73.0597",
    stroke: "#DA4A8E",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M249.094 40.9176C260.117 40.9176 269.053 31.9818 269.053 20.9588C269.053 9.93587 260.117 1 249.094 1C238.071 1 229.135 9.93587 229.135 20.9588C229.135 31.9818 238.071 40.9176 249.094 40.9176Z",
    stroke: "#DA4A8E",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M269.056 44.1182C274.676 44.1182 279.233 39.5617 279.233 33.9409C279.233 28.3202 274.676 23.7637 269.056 23.7637C263.435 23.7637 258.878 28.3202 258.878 33.9409C258.878 39.5617 263.435 44.1182 269.056 44.1182Z",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M235.042 79.8217C240.616 78.8012 253.855 75.1843 251.731 64.6113C250.634 59.1617 245.518 55.2463 231.494 53.7329L232.098 80.2243L237.992 87.0277",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M231.956 66.1875H251.609",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M231.956 73.4418L250.769 71.373",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M231.706 59.5156L249.589 60.5084",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M215.092 121.593C217.202 121.523 221.437 120.766 223.652 116.171C224.513 114.387 224.978 111.686 223.652 110.062L230.629 112.831C231.545 114.678 231.691 117.177 231.503 119.211C231.108 123.446 229.448 125.265 229.448 125.265L220.111 120.28L218.133 130.298C218.133 130.298 210.274 129.972 207.81 123.446L208.99 118.371C209.448 116.254 209.767 115.108 210.031 114.609",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1802 194.486C85.3276 187.689 78.0938 176.866 78.5242 156.213C78.9407 136.185 92.6238 118.371 102.982 111.589",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4608 80.8078C59.6089 80.8078 67.0249 73.3919 67.0249 64.2438C67.0249 55.0957 59.6089 47.6797 50.4608 47.6797C41.3127 47.6797 33.8967 55.0957 33.8967 64.2438C33.8967 73.3919 41.3127 80.8078 50.4608 80.8078Z",
    fill: "#FBF7CE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8071 54.2954C68.4279 54.2954 72.9844 49.7389 72.9844 44.1182C72.9844 38.4974 68.4279 33.9409 62.8071 33.9409C57.1864 33.9409 52.6299 38.4974 52.6299 44.1182C52.6299 49.7389 57.1864 54.2954 62.8071 54.2954Z",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M189.103 158.199L186.576 152.75",
    stroke: "#0E090C",
    strokeWidth: 0.69422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresultFoundImage);
export default __webpack_public_path__ + "static/media/NoresultFoundImage.6329a1f6f458d9a80739ee5529e4cbf0.svg";
export { ForwardRef as ReactComponent };